import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rms-radio',
  standalone: true,
  templateUrl: './radio-field.component.html',
  styleUrls: ['../rms-styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioFieldComponent),
      multi: true
    }
  ],
  imports: [CommonModule]
})
export class RadioFieldComponent implements ControlValueAccessor {
  @Input() options: { value: any; label: string }[] = [];
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() label: string = '';
  @Input() flexRow: boolean = false;

  selectedValue: any;

  onChange = (_: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectValue(value: any) {
    if (!this.disabled) {
      this.selectedValue = value;
      this.onChange(value);
      this.onTouched();
    }
  }
}
